import React, {useState} from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import {InputField} from '../../atoms'
import ActionDialog from '../action-dialog'

const ModalReportConfirmation = ({ showModal, handleClose, i18n }) => {

  const [ receiver, setReceiver ] = useState('');

  // Cerrar por la X, el fondo o Cancelar manda 'Close' para que el llamante no lance el informe
  return (
    <ActionDialog
      open={showModal}
      title={i18n.reports.modalConfirmationTitle}
      onClose={() => handleClose('Close')}
      onConfirm={() => handleClose(receiver)}
      cancelLabel={i18n.reports.modalConfirmationButtonCancel}
      confirmLabel={i18n.reports.modalConfirmationButton}
    >
      <S.Body>
        <S.Text dangerouslySetInnerHTML={{ __html: i18n.reports.reportReceiversTitle }} />
        <InputField value={ receiver } handleOnChange={ (text) => setReceiver(text) }/>
      </S.Body>
    </ActionDialog>
  )
}

ModalReportConfirmation.propTypes = {
  showModal: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
}

const enharce = compose(withI18n)

export default enharce(ModalReportConfirmation)
